'use client';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Invisible focus target. Render this at the spot in the form tree where
 * focus should land on a successful submission. <Form> will call .focus()
 * on this element after a successful result.
 *
 * If <Form.SuccessTarget> is not rendered, <Form> falls back to the next
 * focusable element after the form, or the page's main heading.
 */
export function FormSuccessTarget() {
    // The ref is read by <Form> via a DOM query on the data-success-target attr.
    return (_jsx("div", { "data-form-success-target": "true", tabIndex: -1, "aria-hidden": "true", style: { outline: 'none', position: 'absolute', width: 0, height: 0, overflow: 'hidden' } }));
}
//# sourceMappingURL=FormSuccessTarget.js.map